import { IconProps } from "@design-system/types";

export function ColoredGlobeIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6665 15C1.6665 22.364 7.63584 28.3333 14.9998 28.3333C22.3638 28.3333 28.3332 22.364 28.3332 15C28.3332 7.636 22.3638 1.66666 14.9998 1.66666C7.63584 1.66666 1.6665 7.636 1.6665 15Z"
        stroke="#0046BB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.333 1.73333C16.333 1.73333 20.333 7 20.333 15C20.333 23 16.333 28.2667 16.333 28.2667M13.6663 28.2667C13.6663 28.2667 9.66635 23 9.66635 15C9.66635 7 13.6663 1.73333 13.6663 1.73333M2.50635 19.6667H27.493M2.50635 10.3333H27.493"
        stroke="#0046BB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
